import CrudRepository from './CrudRepository'

export default class MtnAppsRepository extends CrudRepository {
  constructor () {
    super('customerCare/api/app/web/all')
  }
}
